import { Stack, styled } from "@mui/material";
import { toPx } from "../MuiHelpers";
import { BodyTextM, HeadingM } from "../Typography";

const CONTAINER_MD_UP_WIDTH_PX = 700;

export const StackEqualCols = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        flexWrap: "nowrap",
    }),
);

export const StackColItem = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flex: 1,
        px: theme.spacing(2),
    }),
);

export const MainWrapper = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: theme.spacing(6),
        py: theme.spacing(6),
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: { md: toPx(CONTAINER_MD_UP_WIDTH_PX), xs: "100%" },
        mx: "auto",
    }),
);

export const BoldBodyTextM = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        fontWeight: "bold",
    }),
);

export const CardInnerStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: theme.spacing(3),
        my: theme.spacing(4),
    }),
);

export const PageHeading = styled(HeadingM)(({ theme }) =>
    theme.unstable_sx({
        mb: theme.spacing(0),
    }),
);
